module.exports = __webpack_public_path__ + "static/media/success.c13b53e7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Helpers/Storage/Images/success.svg
// module id = 494
// module chunks = 0